// Single shared data source for approved Clinical Insights.
// The Clinical Insights hub and each Insight detail page read from this file.
// Do not duplicate this data in another file. Do not seed sample Insights.
// Content is verbatim from Dr Tania Gurdip Singh's approved brief.

export const APPROVED_CLINICAL_INSIGHTS = [
  {
    slug: "low-platelets-pregnancy-trend",
    testid: "clinical-insight-low-platelets-pregnancy-trend",
    variant: "Decision Point",
    title:
      "Low Platelets in Pregnancy: The Trend May Matter More Than the Number",
    seoTitle:
      "Low Platelets in Pregnancy: Why the Trend Matters | Dr Tania Gurdip Singh",
    metaDescription:
      "Why a stable mild platelet fall may be benign, when a rapid decline needs investigation, and why delivery and epidural plans depend on more than one number.",
    cardDescription:
      "A mildly low platelet count may be harmless, but its timing, trend, associated symptoms and surrounding tests determine whether it is benign or an early warning.",
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Thrombocytopenia in Pregnancy",
  },
  {
    slug: "severe-headache-pregnancy-migraine-red-flags",
    testid: "clinical-insight-severe-headache-pregnancy-migraine-red-flags",
    variant: "Decision Point",
    title:
      "Severe Headache in Pregnancy: When Is It Migraine—and When Is It More?",
    seoTitle:
      "Severe Headache in Pregnancy: Migraine or Warning Sign? | Dr Tania Gurdip Singh",
    metaDescription:
      "How to recognise a familiar migraine pattern in pregnancy, which changes need urgent assessment, and why one normal blood-pressure reading may not be enough.",
    cardDescription:
      "A severe headache may be migraine when it follows a familiar pattern, but a new, sudden or changed headache in pregnancy needs assessment for obstetric and neurological causes.",
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Headache in Pregnancy",
  },
  {
    slug: "polyhydramnios-normal-diabetes-test",
    testid: "clinical-insight-polyhydramnios-normal-diabetes-test",
    variant: "Decision Point",
    title:
      "Increased Fluid Around the Baby with a Normal Diabetes Test: What Else Should Be Considered?",
    seoTitle:
      "Polyhydramnios with a Normal Diabetes Test: What Else Matters? | Dr Tania Gurdip Singh",
    metaDescription:
      "Why a normal diabetes test does not end the assessment of increased amniotic fluid, and how severity, timing, trend and fetal findings guide the next step.",
    cardDescription:
      "A normal diabetes test removes one common cause of polyhydramnios, but severity, timing, trend and the detailed fetal assessment decide what should be checked next.",
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Polyhydramnios in Pregnancy",
  },
  {
    slug: "recurrent-urine-infection-pregnancy",
    testid: "clinical-insight-recurrent-urine-infection-pregnancy",
    variant: "Pitfall to Avoid",
    title:
      "Recurrent Urine Infection in Pregnancy: Why Repeating Antibiotics May Not Be Enough",
    seoTitle:
      "Recurrent Urine Infection in Pregnancy: Why Culture Matters | Dr Tania Gurdip Singh",
    metaDescription:
      "Why repeated urinary symptoms in pregnancy need culture comparison, when recurrence suggests resistance or an underlying cause, and when suppression may be considered.",
    cardDescription:
      "Recurrent urinary symptoms may reflect reinfection, relapse, resistance, contamination or an underlying urinary problem—not simply another infection needing the same antibiotic.",
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Recurrent Urinary Tract Infection in Pregnancy",
  },
  {
    slug: "antenatal-steroids-fetal-lung-maturity",
    testid: "clinical-insight-antenatal-steroids-fetal-lung-maturity",
    variant: "Decision Point",
    title:
      "Before the First Breath: What Do Steroid Injections Actually Do to the Baby's Lungs?",
    seoTitle:
      "Antenatal Steroids and Fetal Lung Maturity | Dr Tania Gurdip Singh",
    metaDescription:
      "Why the placenta—not the lungs—performs gas exchange before birth, how fetal lungs mature, and what antenatal steroids actually change before a preterm birth.",
    cardDescription:
      "Before birth, the placenta—not the lungs—performs gas exchange. Antenatal steroids do not turn a preterm lung into a term lung; they accelerate selected changes that help an immature lung prepare for air breathing after birth.",
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Antenatal Corticosteroids and Fetal Lung Maturity",
  },
];
